import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Dialog, InputText, Toast, Checkbox } from "primereact";
import { TabPanel, TabView } from "primereact/tabview";
import { Dropdown } from "primereact/dropdown";
import { ConfirmDialog, confirmDialog} from "primereact/confirmdialog";

// ------------------- COMPONENTES DE BASE-------------------------------
import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { obtenerCountries } from "../../../../../Base/API/Global/Countries/CountriesRequests";
import { getObtenerTypes } from "../../../../../Base/API/Global/Types/TypeRequest";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { ObtenerCurrency } from "../../../../../Base/API/Global/Currency/CurrencyRequest";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

// ------------------- CONSULTAS A LA API--------------------------------
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { getTerms } from "../../../../../API/Compras/Terms/TermsRequest";
import {
  getProveedor,
  addProveedor,
  RevisarRegistroExonerado,
  getRegistrosExoneradosPrivado
} from "../../../../../API/Compras/Proveedores/ProveedoresRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
const CrudProveedoresModal = ({
  proveedores,
  proveedoresDialog,
  setProveedoresDialog,
  toastRef,
  getProveedores,
  modo,
  setSelected,
}) => {
  // const userAuth = JSON.parse(localStorage.getItem('ppfUser'));

  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);
  const [proveedor, setProveedor] = useState([{}]);
  const [paises, setPaises] = useState([{}]);
  const [estados, setEstados] = useState([{}]);
  const [tipos, setTipos] = useState([{}]);
  const [terminos, setTerminos] = useState([{}]);
  const [monedas, setMonedas] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [tiposPago, setTiposPago] = useState([{}]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [registrosExonerados, setRegistrosExonerados] = useState([]);
  const [estadosRevision, setEstadosRevision] = useState([]);
  const [estadosRegistros, setEstadosRegistros] = useState([]);
  const { userAuth } = useContext(AuthContext);

  const USUARIO_PERMITIDO_EDITAR_REGISTRO = 154; 
  const puedeEditarRegistroExonerado = Number(userAuth?.IdUser) === USUARIO_PERMITIDO_EDITAR_REGISTRO;

  // Categorias de proveedores
  const categorys = [
    { IdCategory: 1, Category: "Proveedor Compras" },
    { IdCategory: 2, Category: "Proveedor Varios" },
  ];

  //formato de fecha
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear().toString().slice(-2); // Obtener solo los últimos dos dígitos del año
    let hours = date.getHours();
    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convertir las horas al formato de 12 horas
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${meridiem}`;
  };

  // Valores iniciales del formulario
  const initialValues = {
    IdVendor: -1,
    IdStatus: "",
    RTN: "",
    CustomerName: "",
    NombreComercial: "",
    // IdType: "",
    Address: "",
    City: "",
    State: "",
    IdCountry: "",
    ZipCode: "",
    Telefono: "",
    Email: "",
    Contact: "",
    DateUpdate: formatDate(new Date()),
    CodigoProveedor: "",
    IdTerm: "",
    IdCategory: null,
    IdMonedaPago: null,
    Categoria: null,
    MonedaPago: null,
    TipoPago: null,
    EstadoRevision: null,
    IdStatusRevision: null,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  // Función para obtener los valores iniciales del formulario
  const getValoresIniciales = async () => {
    setLoading(true);

    const provee = await getProveedor();
    const estadosTempo = await getEstadosCategory("General");
    const estadosRevisionTemp = await getEstadosCategory("Revision Proveedor");
    const estadosRegistrosTemp = await getEstadosCategory("Registro Exonerado");
    console.log("ESTADOS REGISTRO EXONERADO:", estadosRegistrosTemp);
    const estadosRevisionList = Array.isArray(estadosRevisionTemp)
      ? estadosRevisionTemp
      : [];
    const estadoRevisionActual = proveedores?.IdStatusRevision
      ? estadosRevisionList.find(
          (estado) => estado.IdStatus === proveedores.IdStatusRevision,
        )
      : estadosRevisionList.find((estado) => estado.StatusName === "Pendiente");
    const pais = await obtenerCountries();
    const tipo = await getObtenerTypes();
    const term = await getTerms();
    const moneda = await ObtenerCurrency();

    const proveeList = Array.isArray(provee) ? provee : [];
    const estadosList = Array.isArray(estadosTempo) ? estadosTempo : [];
    const estadosRegistrosList = Array.isArray(estadosRegistrosTemp)? estadosRegistrosTemp : [];
    console.log("ESTADOS REGISTRO EXONERADO LIST:", estadosRegistrosList);
    const paisList = Array.isArray(pais) ? pais : [];
    const tipoList = Array.isArray(tipo) ? tipo : [];
    const tiposPagoList = tipoList.filter((t) => t.TypeCategory === "PurchaseRequests",);
    const termList = Array.isArray(term) ? term : [];
    const monedaList = Array.isArray(moneda) ? moneda : [];

    setProveedor(proveeList);
    setEstados(estadosList);
    setEstadosRevision(estadosRevisionList);
    setEstadosRegistros(estadosRegistrosList);
    setPaises(paisList);
    setTipos(tipoList);
    setTiposPago(tiposPagoList);
    setTerminos(termList);
    setMonedas(monedaList);

    const estadoInicial =
      modo === "Crear"
        ? estadosList[0]
        : estadosList.find((e) => e.IdStatus === proveedores?.IdStatus);

    setValues({
      ...proveedores,
      Estado: estadoInicial,
      EstadoRevision: estadoRevisionActual,
      // EstadoRevision: estadosRevisionList.find(
      //   (e) => e.IdStatus === proveedores?.IdStatusRevision,
      // ),
      DateUpdate:
        modo === "Crear"
          ? formatDate(new Date())
          : formatDate(proveedores.DateUpdate),
      Tipo: tipoList.find((t) => proveedores?.IdType === t.IdType),
      Pais: paisList.find((p) => proveedores?.IdCountry === p.IdCountry),
      Term: termList.find((t) => proveedores?.IdTerm === t.IdTerm),
      Categoria: categorys.find((c) => c.IdCategory === proveedores?.IdCategory,),
      MonedaPago: monedaList.find((m) => m.IdCurrency === proveedores?.IdMonedaPago,),
      TipoPago: tiposPagoList.find((t) => t.IdType === proveedores?.IdType),
    });

    if (proveedores?.IdVendor > 0) {
      const registros = await getRegistrosExoneradosPrivado( proveedores.IdVendor);

      const registrosList = Array.isArray(registros)
        ? registros
        : Array.isArray(registros?.data)
          ? registros.data
          : [];

      console.log("REGISTROS EXONERADOS MODAL:", {
        IdVendor: proveedores.IdVendor,
        respuesta: registros,
        registrosList,
      });

      setRegistrosExonerados(registrosList);
    } else {
      setRegistrosExonerados([]);
    }
    setLoading(false);
  };

  const onHide = () => {
    setProveedoresDialog(false);
    resetForm();
    setShow(false);
    setSelected([]);
    setRegistrosExonerados([]);
    setActiveIndex(0);
  };

  const limpiarRTN = (rtn) => {
    return String(rtn || "")
      .replace(/-/g, "")
      .replace(/\s/g, "")
      .trim();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.CustomerName) {
      error.CustomerName = true;
      error.error = true;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.Email)) {
      error.Email = true;
      error.error = true;
    }
    if (!values.Pais?.IdCountry) {
      error.IdCountry = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarProveedor = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingProveedor = proveedor.find((pr) => pr.CustomerName === values?.CustomerName,);
      const existingRTN = proveedor.find((pr) => limpiarRTN(pr?.RTN) === limpiarRTN(values?.RTN) && limpiarRTN(values?.RTN));

      if (existingProveedor && (modo === "Crear" || existingProveedor.IdVendor !== values.IdVendor)) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe un registro con ese nombre",
        );
      } else if (existingRTN && (modo === "Crear" || existingRTN.IdVendor !== values.IdVendor)) {
        toastShow(
          toast,
          "error",
          "RTN duplicado",
          "No se puede agregar el proveedor porque ya existe un proveedor con ese mismo RTN.",
        );

      } else {
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdVendor: values?.IdVendor,
          IdStatus: estadoId,
          RTN: values.RTN,
          CustomerName: values.CustomerName,
          NombreComercial: values.NombreComercial,
          // IdType: values.Tipo?.IdType,
          IdType: values.TipoPago?.IdType,
          Address: values.Address,
          City: values.City,
          State: values.State,
          IdCountry: values.Pais?.IdCountry,
          ZipCode: values.ZipCode,
          Telefono: values.Telefono,
          Email: values.Email,
          Contact: values.Contact,
          DateUpdate: values.DateUpdate,
          CodigoProveedor: values.CodigoProveedor,
          IdTerm: values.Term?.IdTerm,
          IdCategory: values.Categoria?.IdCategory,
          IdMonedaPago: values.MonedaPago?.IdCurrency,
          IdStatusRevision: values.EstadoRevision?.IdStatus,
        };
        await addProveedor(a);
        if (modo === "Crear") {
          onHide();
          toastShow(toastRef, "success", "Proveedor agregado exitosamente.");
          getProveedores();
        } else {
          onHide();
          toastShow(toastRef, "success", "Proveedor actualizado exitosamente.");
          getProveedores();
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarProveedor();
          } else {
            agregarProveedor();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (proveedoresDialog) {
      getValoresIniciales();
    }
  }, [proveedoresDialog]);

  useEffect(() => {
    if (proveedoresDialog) {
      setActiveIndex(0);
    }
  }, [proveedoresDialog]);

  const revisarRegistroExonerado = async (rowData) => {
    confirmDialog({
      message: `¿Está seguro que desea revisar el registro exonerado ${rowData?.RegistroExonerado || ""}?`,
      header: "Confirmar revisión",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí, revisar",
      rejectLabel: "Cancelar",
      accept: async () => {
        const result = await RevisarRegistroExonerado(
          rowData.IdRegistro,
          userAuth?.IdUser
        );

        const registros = await getRegistrosExoneradosPrivado(
          proveedores.IdVendor
        );

        const registrosList = Array.isArray(registros)
          ? registros
          : Array.isArray(registros?.data)
            ? registros.data
            : [];

        setRegistrosExonerados(registrosList);

        toastShow(
          toast,
          "success",
          "Registro revisado",
          "El registro exonerado fue revisado correctamente."
        );
      },
    });
  };

  const changeEstadoRegistroExonerado = ({ data, api }) => {
    return (
      <Dropdown
        value={estadosRegistros.find(
          (estado) => Number(estado.IdStatus) === Number(data.IdEstado)
        )}
        options={estadosRegistros}
        optionLabel="StatusName"
        filter
        filterBy="StatusName"
        style={{ width: "100%" }}
        appendTo={document.body}
        panelStyle={{ zIndex: 99999 }}
        onChange={async (e) => {
          await RevisarRegistroExonerado(
            data.IdRegistro,
            userAuth?.IdUser,
            e.value.IdStatus
          );

          const registros = await getRegistrosExoneradosPrivado(
            proveedores.IdVendor
          );

          const registrosList = Array.isArray(registros)
            ? registros
            : Array.isArray(registros?.data)
              ? registros.data
              : [];

          setRegistrosExonerados(registrosList);

          toastShow(
            toast,
            "success",
            "Estado actualizado",
            "El estado del registro exonerado fue actualizado correctamente."
          );

          api.stopEditing();
        }}
      />
    );
  };

  const columnRegistrosExonerados = [
    {
      field: "IdRegistro",
      header: "ID",
      className: "XXsmall",
      filter: true,
      hidden: Number(userAuth?.IdRol) === 1,
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      filter: true,
      Format: "Estado",
      editable: puedeEditarRegistroExonerado,
      cellEditor: changeEstadoRegistroExonerado,
      backgroundField: "Background",
      colorField: "Color",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "RegistroExonerado",
      header: "Registro",
      headerEn: "Record",
      className: "large",
      filter: true,
    },
    {
      field: "StartDate",
      header: "Fecha Inicio",
      headerEn: "Start Date",
      className: "small",
      filter: true,
      Format: "Datetime",
    },
    {
      field: "FechaVencimientoStr",
      header: "Fecha Vencimiento",
      headerEn: "Date Expired",
      className: "small",
      filter: true,
      Format: "Datetime",
    },
    {
      field: "UserName",
      header: "Usuario Reviso",
      headerEn: "User Review",
      className: "large",
      filter: true,
    },
    {
      field: "DateRevisoStr",
      header: "Fecha Revisión",
      headerEn: "Review Date",
      className: "small",
      filter: true,
      Format: "Datetime",
    },
    {
      field: "RegistroExoneradoName",
      header: "Registro Exo...",
      headerEn: "Exempt Record",
      className: "small",
      filter: true,
    },
    {
      field: "ConstPagosName",
      header: "Const. Pago...",
      headerEn: "Payment Cert.",
      className: "small",
      filter: true,
    },
    {
      field: "Revisar",
      header: "Revisar",
      className: "XXsmall",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      width: 65,
      Format: "Template",
      body: (rowData) => {
        const revisado = !!rowData?.IdUsuarioReviso;
        const pendiente =
          String(rowData?.StatusName || "").toLowerCase() === "pendiente";

        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              icon={
                revisado
                  ? "pi pi-check-circle"
                  : pendiente
                    ? "pi pi-clock"
                    : "pi pi-eye"
              }
              className={
                revisado
                  ? "p-button-text p-button-success p-button-sm"
                  : pendiente
                    ? "p-button-text p-button-warning p-button-sm"
                    : "p-button-text p-button-sm"
              }
              style={{
                padding: 0,
                width: 22,
                height: 22,
              }}
              tooltip={
                revisado
                  ? "Registro revisado"
                  : pendiente
                    ? "Pendiente de revisión"
                    : "Revisar registro exonerado"
              }
              tooltipOptions={{ position: "left" }}
              disabled={revisado}
              onClick={() => revisarRegistroExonerado(rowData)}
            />
          </div>
        );
      },
    },
  ];

  const tableRegistrosExonerados = {
    Columns: columnRegistrosExonerados,
    Data: registrosExonerados,
    key: "IdRegistro",
    scrollHeight: "100%",
  };

  const dialogTitle =
    modo === "Crear" ? "Nuevo Proveedor" : "Modificar Proveedor";

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <ConfirmDialog />
      <Dialog
        visible={proveedoresDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="DialogP">
          <Loader loading={loading} querySelector={"#DialogP"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
              <h3 className="fw-bold">{values.CodigoProveedor}</h3>
            </div>

            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />
            <TabView
              className="col-12 homeTabView"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Información General">
                {/* NOMBRE LEGAL Y NOMBRE COMERCIAL */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="CustomerName"
                        value={values.CustomerName}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={error.CustomerName ? "p-invalid" : ""}
                      />
                      <label htmlFor="CustomerName">Nombre Legal</label>
                    </span>
                  </div>

                  <div className="field col-6 me-2">
                    <span className="p-float-label">
                      <InputText
                        name="NombreComercial"
                        value={values.NombreComercial}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                      />
                      <label htmlFor="NombreComercial">Nombre Comercial</label>
                    </span>
                  </div>
                </div>

                {/* RTN y TELEFONO */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="RTN"
                        value={values.RTN}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="RTN">RTN</label>
                    </span>
                  </div>
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="Telefono"
                        value={values.Telefono}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Minimo">Telefono</label>
                    </span>
                  </div>
                </div>

                {/* EMAIL Y CONTACTO */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="Email"
                        value={values.Email}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        className={error.Email ? "p-invalid" : ""}
                      />
                      <label htmlFor="Email">Email</label>
                      {error.Email && (
                        <small className="p-error">
                          Correo Electronico Ivalido. E.g. example@email.com.
                        </small>
                      )}
                    </span>
                  </div>
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="Contact"
                        value={values.Contact}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Minimo">Contacto</label>
                    </span>
                  </div>
                </div>

                {/* PAIS Y CIUDAD */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Pais"}
                        value={values.Pais}
                        items={paises}
                        field={"Country"}
                        label={"País"}
                        handleInputChange={handleInputChange}
                        className={error.IdCountry ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="City"
                        value={values.City}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Minimo">Ciudad</label>
                    </span>
                  </div>
                </div>

                {/* ESTADO Y DIRECCIÓN */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="State"
                        value={values.State}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Minimo">Estado</label>
                    </span>
                  </div>
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="Address"
                        value={values.Address}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Minimo">Dirección</label>
                    </span>
                  </div>
                </div>

                {/* ZIP CODE Y TÉRMINO */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="ZipCode"
                        value={values.ZipCode}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                      <label htmlFor="Minimo">ZipCode</label>
                    </span>
                  </div>
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Term"}
                        value={values.Term}
                        items={terminos}
                        field={"Term"}
                        label={"Término"}
                        handleInputChange={handleInputChange}
                      />
                    </span>
                  </div>
                </div>

                {/* MONEDA DE PAGO Y TIPO DE PAGO */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"MonedaPago"}
                        value={values.MonedaPago}
                        items={monedas}
                        field={"Currency"}
                        label={"Moneda Pago"}
                        handleInputChange={handleInputChange}
                      />
                    </span>
                  </div>
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"TipoPago"}
                        value={values.TipoPago}
                        items={tiposPago}
                        field={"Type"}
                        label={"Tipo Pago"}
                        handleInputChange={handleInputChange}
                      />
                    </span>
                  </div>
                </div>

                {/* ESTADO REVISION Y ESTADO */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"EstadoRevision"}
                        value={values.EstadoRevision}
                        items={estadosRevision}
                        field={"StatusName"}
                        label={"Estado Revisión"}
                        handleInputChange={handleInputChange}
                        enable={false}
                      />
                    </span>
                  </div>

                  <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Estado"}
                        value={values.Estado}
                        items={estados}
                        field={"StatusName"}
                        label={"Estado"}
                        handleInputChange={handleInputChange}
                        enable={values?.IdVendor > 0}
                      />
                    </span>
                  </div>
                </div>
              </TabPanel>
              {values?.IdVendor > 0 && (
                <TabPanel header="Registro exonerado">
                  <div style={{ height: "37vh" }}>
                    <AgGrid table={tableRegistrosExonerados} />
                  </div>
                </TabPanel>
              )}
            </TabView>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CrudProveedoresModal;
